import { createContext } from "react";
const SeoDetailsContext = createContext({});
export default SeoDetailsContext;
